import { render, staticRenderFns } from "./activeRecord.vue?vue&type=template&id=1921909e&scoped=true&"
import script from "./activeRecord.vue?vue&type=script&lang=js&"
export * from "./activeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921909e",
  null
  
)

export default component.exports